import { BrandParentsSelect } from './brand-parents-select';

export { BrandParentsSelect };
